import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Keyable from '../../../../../types/keyable';

export interface GeneralInfoSocialNetworkFormState extends Keyable {
  name: string | null;
  url: string;
}

export const generalInfoSocialNetworksSlice = createSlice({
  name: 'generalInfoSocialNetworks',
  initialState: [] as GeneralInfoSocialNetworkFormState[],
  reducers: {
    setGeneralInfoSocialNetworksStateDefault: () => {
      return [];
    },
    submitGeneralInfoSocialNetworks: (state, action: PayloadAction<GeneralInfoSocialNetworkFormState[]>) => {
      return action.payload;
    },
  },
});

export const { setGeneralInfoSocialNetworksStateDefault, submitGeneralInfoSocialNetworks } = generalInfoSocialNetworksSlice.actions;

export default generalInfoSocialNetworksSlice.reducer;
